import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/24/solid';
import { cn } from '@plato/ui/util/classes';

type Props = {
    up?: boolean | null;
    className?: string;
};

export function DeltaArrow({ up, className = '' }: Props) {
    if (up === undefined || up === null) {
        return null;
    }
    if (up) {
        return <ArrowUpIcon className={cn('h-4 w-4 text-green-600', className)} />;
    } else {
        return <ArrowDownIcon className={cn('h-4 w-4 text-red-600', className)} />;
    }
}
